import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/api";
import { LogoMark } from "@/components/Logo";

/**
 * Handles the return from Emergent Google Auth:
 * exchanges #session_id for a session (backend call), then redirects to the CMS.
 */
export default function AuthCallback() {
  const nav = useNavigate();
  const { completeGoogle } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const match = window.location.hash.match(/session_id=([^&]+)/);
    const sessionId = match && match[1];
    // Remove the fragment so the session_id is never kept in history
    window.history.replaceState(null, "", window.location.pathname);

    if (!sessionId) {
      nav("/elder-login", { replace: true });
      return;
    }

    completeGoogle(sessionId)
      .then((user) => nav("/cms", { replace: true, state: { user } }))
      .catch((err) => {
        toast.error(formatApiError(err.response?.data?.detail) || "Google sign-in failed. Please try again.");
        nav("/elder-login", { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-background" data-testid="auth-callback">
      <LogoMark className="h-14 w-auto text-ink animate-pulse" />
      <p className="eyebrow">Signing you in…</p>
    </div>
  );
}
